export default (str, fallback = "GET") => {
  const method = str.toUpperCase()
  const methods = ["GET", "POST"]
  return methods.includes(method) ? method : fallback
}
